export enum LocationType {
	COUNTRY = 1,
	STATE = 2,
	CONTINENT = 3,
}
